import AutocaptureConfig from "../../../../contents/docs/product-analytics/_snippets/multilanguage/autocapture-config.mdx";
import * as React from 'react';
export default {
  AutocaptureConfig,
  React
};